/**
 * Hygge Apps — Second-home landing page
 * Vanilla JS behavior for: variant picker, gallery thumbnails, reviews carousel,
 * and AJAX add-to-cart. No dependencies. Safe to load on any Online Store 2.0 theme.
 * (resync)
 */
(function () {
  'use strict';

  function initLanding(root) {
    if (!root || root.dataset.hyggeInit === 'true') return;
    root.dataset.hyggeInit = 'true';

    initVariantPicker(root);
    initGallery(root);
    initReviewsCarousel(root);
    initAddToCart(root);
    initBlockAddToCart(root);
    initVideoModal(root);
  }

  function initVideoModal(root) {
    root.querySelectorAll('[data-hygge-video-modal]').forEach(function (modal) {
      var video = modal.querySelector('[data-hygge-video]');
      if (!video) return;

      root.querySelectorAll('[data-hygge-video-open="' + modal.id + '"]').forEach(function (opener) {
        opener.addEventListener('click', function () {
          video.play().catch(function () {});
        });
      });

      modal.querySelectorAll('[data-hygge-video-close]').forEach(function (closer) {
        closer.addEventListener('click', function () {
          video.pause();
          video.currentTime = 0;
        });
      });
    });
  }

  function initVariantPicker(root) {
    var radios = root.querySelectorAll('.hygge-variant-radio');
    if (!radios.length) return;

    var priceEl = root.querySelector('[data-hygge-price]');
    var nameEl = root.querySelector('[data-hygge-name]');
    var variantInput = root.querySelector('[data-hygge-variant-input]');
    var submitBtn = root.querySelector('[data-hygge-submit]');
    var featurePanels = root.querySelectorAll('[data-hygge-feature-panel]');
    var mainImg = root.querySelector('[data-hygge-gallery-main]');
    var errorBox = root.querySelector('[data-hygge-error]');

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (!radio.checked) return;

        if (priceEl) priceEl.textContent = radio.dataset.price || '';
        if (nameEl) nameEl.textContent = radio.dataset.name || '';
        if (variantInput) variantInput.value = radio.value;

        var available = radio.dataset.available === 'true';
        if (submitBtn) {
          submitBtn.disabled = !available;
          submitBtn.classList.toggle('is-disabled', !available);
          submitBtn.textContent = available ? (radio.dataset.cta || 'Add to cart') : 'Sold out';
        }
        if (errorBox) {
          errorBox.textContent = '';
          errorBox.classList.remove('is-visible');
        }

        featurePanels.forEach(function (panel) {
          panel.classList.toggle('is-active', panel.dataset.variantId === radio.value);
        });

        if (mainImg && radio.dataset.image) {
          mainImg.src = radio.dataset.image;
        }
      });
    });
  }

  function initGallery(root) {
    var thumbs = root.querySelectorAll('[data-hygge-thumb]');
    var mainImg = root.querySelector('[data-hygge-gallery-main]');
    var mainWrap = root.querySelector('.hygge-gallery__main');
    if (!thumbs.length || !mainImg) return;

    var thumbsArr = Array.prototype.slice.call(thumbs);
    var currentIndex = 0;
    thumbsArr.forEach(function (t, i) {
      if (t.classList.contains('is-active')) currentIndex = i;
    });

    function showImage(index) {
      var count = thumbsArr.length;
      currentIndex = (index + count) % count;
      var full = thumbsArr[currentIndex].dataset.full;
      if (full) mainImg.src = full;
      thumbsArr.forEach(function (t, i) { t.classList.toggle('is-active', i === currentIndex); });
    }

    thumbsArr.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () {
        showImage(i);
      });
    });

    if (mainWrap && thumbsArr.length > 1) {
      var touchStartX = 0;
      var touchStartY = 0;
      var touching = false;

      mainWrap.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) return;
        touching = true;
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
      }, { passive: true });

      mainWrap.addEventListener('touchend', function (e) {
        if (!touching) return;
        touching = false;
        var touch = e.changedTouches[0];
        var deltaX = touch.clientX - touchStartX;
        var deltaY = touch.clientY - touchStartY;
        var SWIPE_THRESHOLD = 40;
        if (Math.abs(deltaX) < SWIPE_THRESHOLD || Math.abs(deltaX) < Math.abs(deltaY)) return;
        showImage(currentIndex + (deltaX < 0 ? 1 : -1));
      }, { passive: true });
    }
  }

  function initReviewsCarousel(root) {
    var track = root.querySelector('[data-hygge-review-track]');
    var prevBtn = root.querySelector('[data-hygge-review-prev]');
    var nextBtn = root.querySelector('[data-hygge-review-next]');
    if (!track) return;

    function scrollByCard(direction) {
      var card = track.querySelector('.hygge-review-card');
      if (!card) return;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap || '16') || 16;
      var amount = (card.getBoundingClientRect().width + gap) * direction;
      track.scrollBy({ left: amount, behavior: 'smooth' });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { scrollByCard(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollByCard(1); });
  }

  function initAddToCart(root) {
    var form = root.querySelector('.hygge-product-form');
    if (!form) return;

    var submitBtn = form.querySelector('[data-hygge-submit]');
    var errorBox = root.querySelector('[data-hygge-error]');
    var scriptTag = document.querySelector('script[data-hygge-section-id]');
    var cartAddUrl = (scriptTag && scriptTag.dataset.cartAddUrl) || '/cart/add.js';
    var cartUrl = (scriptTag && scriptTag.dataset.cartUrl) || '/cart';

    form.addEventListener('submit', function (evt) {
      evt.preventDefault();
      if (submitBtn && submitBtn.disabled) return;

      var originalText = submitBtn ? submitBtn.textContent : '';
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Adding…';
      }
      if (errorBox) {
        errorBox.textContent = '';
        errorBox.classList.remove('is-visible');
      }

      var formData = new FormData(form);

      fetch(cartAddUrl, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData
      })
        .then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok) {
              var message = (data && data.description) || 'That item couldn\'t be added to your cart.';
              throw new Error(message);
            }
            return data;
          });
        })
        .then(function () {
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          if (typeof window.oaiq === 'function') {
            window.oaiq('measure', 'items_added', { type: 'contents' });
          }
          if (typeof window.gtag_report_conversion === 'function') {
            gtag_report_conversion(cartUrl);
          } else {
            window.location.href = cartUrl;
          }
        })
        .catch(function (err) {
          if (errorBox) {
            errorBox.textContent = err.message || 'Something went wrong. Please try again.';
            errorBox.classList.add('is-visible');
          }
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = originalText;
          }
        });
    });
  }

  // Featured-product blocks: any number of independent add-to-cart forms,
  // each for its own merchant-selected product/variant.
  function initBlockAddToCart(root) {
    var forms = root.querySelectorAll('.hygge-block-product-form');
    if (!forms.length) return;

    var scriptTag = document.querySelector('script[data-hygge-section-id]');
    var cartAddUrl = (scriptTag && scriptTag.dataset.cartAddUrl) || '/cart/add.js';
    var cartUrl = (scriptTag && scriptTag.dataset.cartUrl) || '/cart';

    forms.forEach(function (form) {
      var submitBtn = form.querySelector('[data-hygge-block-submit]');
      var errorBox = form.querySelector('[data-hygge-block-error]');

      form.addEventListener('submit', function (evt) {
        evt.preventDefault();
        if (submitBtn && submitBtn.disabled) return;

        var originalText = submitBtn ? submitBtn.textContent : '';
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = 'Adding…';
        }
        if (errorBox) {
          errorBox.textContent = '';
          errorBox.classList.remove('is-visible');
        }

        var formData = new FormData(form);

        fetch(cartAddUrl, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData
        })
          .then(function (response) {
            return response.json().then(function (data) {
              if (!response.ok) {
                var message = (data && data.description) || 'That item couldn\'t be added to your cart.';
                throw new Error(message);
              }
              return data;
            });
          })
          .then(function () {
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            if (typeof window.oaiq === 'function') {
              window.oaiq('measure', 'items_added', { type: 'contents' });
            }
            if (typeof window.gtag_report_conversion === 'function') {
              gtag_report_conversion(cartUrl);
            } else {
              window.location.href = cartUrl;
            }
          })
          .catch(function (err) {
            if (errorBox) {
              errorBox.textContent = err.message || 'Something went wrong. Please try again.';
              errorBox.classList.add('is-visible');
            }
            if (submitBtn) {
              submitBtn.disabled = false;
              submitBtn.textContent = originalText;
            }
          });
      });
    });
  }

  function initAll() {
    document.querySelectorAll('.hygge-landing').forEach(initLanding);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init when the section is added/re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', function (evt) {
    var root = evt.target.querySelector ? evt.target.querySelector('.hygge-landing') : null;
    if (root) {
      root.dataset.hyggeInit = 'false';
      initLanding(root);
    }
  });
})();
